define('app-SearchResults/modules/batBelt/viewModel',['./settings', "util", '../../../app-Search/core/service', '../../core/broker', 'knockout', '../../../app-blazy/module', 'underscore'], function (settings, util, Service, broker, ko, blazy, _) {
    return function (globalSettings) {
        var self = this;
        self.Service = new Service(globalSettings.searchStorageKey);
        self.TotalResults = ko.observable(0);
        self.ChosenSearchTags = ko.observableArray([]);
        self.map = null;
        self.Key = '';

        self.DirectUrl = function (tag) {
            var obj = [{ value: tag.value, description: tag.description, type: tag.type }];
            var url = settings.searchPageUrl + '#app-Search-Tags|' + JSON.stringify(obj);
            return url;
        };

        self.RemoveSearchTag = function (term) {
            self.Service.removeTerm(term).Notify();
        };

        // Since the search results total lives in a different section of the page, hoover it up
        // here so we can display it in-place correctly... callTracker var & if statement makes it only fire when it changes to minimise the util.satelliteTrack calls
        var callTracker = true;
        setInterval(function () {
            if (parseInt(self.TotalResults()) != parseInt($('#TotalNumberOfSearchResults').val())) {
                var searchResults = $('#TotalNumberOfSearchResults').val();

                self.TotalResults(searchResults);
                AdlAddUpdateItem('searchResults', searchResults);
                callTracker = true;
            } else {
                if (callTracker) {
                    // Everything loaded? Good, call the function to populate the search results vars
                    createAASearchInformation();
                    util.satelliteTrack('travel search results');
                    callTracker = false;
                }
            }
            blazy.loadLazy();
        }, 500);

        function createAASearchInformation() {
            //list of products
            var listOfProducts = [];

            $('.searchResult').each(function (i) {
                listOfProducts.push($(this).attr('productcode'));
            });

            AdlAddUpdateItem('productList', listOfProducts);
            localStorage.setItem('metaProductList', listOfProducts.toString());
            AdlAddUpdateArrayItem('metaProductList', listOfProducts);

            //search results page number 
            var searchResultsPage = $('#pagination_links_foot>.active').text().trim();
            AdlAddUpdateItem('searchResultsPage', searchResultsPage);
        };

        function constructor() {
            self.Key = self.Service.observe(function () {
                self.ChosenSearchTags(self.Service.allTerms());
            });
        };

        constructor();

        var setUpsearchInit = _.debounce(searchInit, 200); // call searchInit function - with slight delay
        setUpsearchInit();
    };
});

function changeDefaultLabels() {
    $("#searchControlContainer .styles").addClass('disabled');
    $("#searchControlContainer .date").addClass('disabled');
    $("#searchControlContainer .settings").addClass('disabled');

    if ($('#searchStylesTab').text() === 'What') {
        $('#searchStylesTab').text('Any');
    }

    if ($('#searchDateTab').text() === 'When') {
        $('#searchDateTab').text('Any');
    }

    if ($('#searchSettingsTab').text() === 'More') {
        $('#searchSettingsTab').text('All');
    }
}

// initialize search fields 
function searchInit() {
    changeDefaultLabels();

    //open Search Control - on desktop devices ONLY (assumes window width > 480px )
    if ($(window).width() > 480) {
        $("#searchControlContainer").css("display", "block");
        $(".searchMiniCollapse").css("display", "none");
        $(".closeSearch-fullwidth").css("display", "none");
    }

    //hide the input fields
    $("#destinationInputControl").addClass("hidden");
    $("#noEditDestination").removeClass("hidden");
    $("#destinationSearchTextBox").addClass("hidden");
    $(".searchMiniNavTab").addClass("searchMiniNavTab-x").removeClass("searchMiniNavTab").wrap('<span class="onTheFlyWrap"></span>');
    $(".onTheFlyWrap").wrap('<div id="selectedTags" class="btn-group-xs" data-bind="foreach: FilteredTags" style="display: block; width: "></div>');

    $(".btn-tag > a").addClass("killed_link");

    $("#noEditDestination").empty(); // ensure non-editable field is empty to start

    if ($('.sel_destin').length === 0) {
        $("#noEditDestination").append("<span class=''><a href='#' class='killed_link'><span data-bind='text: description'>Anywhere</span></a></span>");
    } else if ($('.sel_destin').length === 1) {
        $("#noEditDestination").append("<span class=''><a href='#' class='killed_link'><span data-bind='text: description'>" + $('.sel_destin').html() + "</span></a></span>");
    } else {
        $("#noEditDestination").append("<span class=''><a href='#' class='killed_link'><span data-bind='text: description'>" + $('.sel_destin').first().html() + " + " + ($('.sel_destin').length - 1) + " more</span></a></span>");
    }

    // swap run search / edit button visibility
    $("#runSearchButton").addClass("hidden");
    //$("#editSearchButton").removeClass("hidden");

    //$("#editSearchButton").click(function () {
    //    //$("#searchControl").fadeIn("slow");
    //    $('.travelMenu').addClass('closeMenu');
    //    $("#searchMobile").fadeIn("slow");
    //    $("#editSearchButton").addClass("hidden");

    //});

    $('.navArrow').addClass('hidden');
};
